import React from 'react';
import styled from 'styled-components';

import { Banned as BannedIcon } from '@icons/dialer/calls';

export interface IBannedCallingState {
  className?: string;
  onSubmit: () => void;
}

const CallingState = ({ className, onSubmit }: IBannedCallingState) => {
  const handleSubmit = event => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <StyledCallingState className={className} onSubmit={handleSubmit}>
      <StyledContent>
        <BannedIcon width={27} />
        <StyledInfo>
          <span>Вы заблокированы и не можете принимать звонки!</span>
        </StyledInfo>
        <StyledAccept>Разблокировать</StyledAccept>
      </StyledContent>
    </StyledCallingState>
  );
};

const StyledCallingState = styled.form`
  background-image: linear-gradient(to left, #e50e5c, #ec8926);
  height: 100%;
  width: 100%;
`;

const StyledContent = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

const StyledInfo = styled.div`
  color: #fff;
  margin-left: 15px;

  span {
    font-size: 17px;
  }
`;

const StyledAccept = styled.button`
  background-color: #fff;
  border: none;
  border-radius: 30px;
  color: #17181a;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  height: 40px;
  padding: 0 43px;

  ${StyledInfo} + & {
    margin-left: 24px;
  }
`;

export default CallingState;
